
import React, { Component } from 'react';
import cx from 'classnames';
import moment from 'moment';

import SVG from 'react-inlinesvg';
import { Text, NUMERIC_MEDIA_SIZES, Dropdown, Icon, Button, Tabs } from '../../../ui-kit';
import { NoInsightsAvailable, InsightsError } from '../../../assets/images';
import Leaderboard from './components/Leaderboard';
import '../styles/_right-drawer-insights.scss';

































// TypeScript & flow likely do this even better, though can refactor later if it only ends up in stories/tests...
export const FILTERS_ENUM = Object.freeze({
  TODAY: 'TODAY',
  LAST_7_DAYS: 'LAST_7_DAYS',
  LAST_30_DAYS: 'LAST_30_DAYS'
});

const FILTER_OPTION_TO_CREATED_AT = {
  [FILTERS_ENUM.TODAY]: moment.utc().startOf('day').toISOString(),
  [FILTERS_ENUM.LAST_7_DAYS]: moment.utc().subtract(7, 'd').toISOString(),
  [FILTERS_ENUM.LAST_30_DAYS]: moment.utc().subtract(30, 'd').toISOString()
};

const DEFAULT_FILTERS = [
{ id: FILTERS_ENUM.TODAY, label: 'Today' },
{ id: FILTERS_ENUM.LAST_7_DAYS, label: 'Last 7 Days' },
{ id: FILTERS_ENUM.LAST_30_DAYS, label: 'Last 30 Days' }];


const HEIGHT_OF_GRAPH = 200;
const NUMBER_OF_GRAPH_VALUES = 15;
const MODAL_MOUSE_OFFSET = 210;

const COLOUR_LIST = [
'#ffce44',
'#a65af2',
'#f118f8'];


const ERROR_STAT = [{ label: 'There was an error fetching statistics', value: '' }];

export default class RightDrawerInsights extends Component


{


  static defaultProps = {
    filters: DEFAULT_FILTERS
  };

  constructor(props) {
    super(props);

    this._mousePosition = { x: 0, y: 0 };

    const { startWithLeaderboardTab } = this.props;

    this.state = {
      selectedFilter: FILTERS_ENUM.LAST_7_DAYS,
      stats: [],
      highestStats: [],
      isTabInsights: !startWithLeaderboardTab,
      errorFetching: false,
      modalOffset: 0
    };
  }

  componentDidMount() {
    this.fetchData();
    window.addEventListener('mousemove', this.setMousePosition);
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedFilter } = this.state;

    if (prevState.selectedFilter !== selectedFilter) {
      this.fetchData();
    }
  }

  setMousePosition = (e) => {
    this._mousePosition = {
      x: e.screenX,
      y: e.screenY
    };
  };

  fetchData = async () => {
    const {
      getOrgTotalEngagements,
      getOrgHighestEngagements,
      productName: productShortName,
      organisationId,
      timezone
    } = this.props;

    const { selectedFilter } = this.state;
    const createdAt = [FILTER_OPTION_TO_CREATED_AT[selectedFilter]];

    if (getOrgTotalEngagements) {
      const { data, errors } = await getOrgTotalEngagements({
        createdAt,
        productShortName,
        organisationId,
        timezone
      });
      if (errors || !data || !data.getOrgTotalEngagements) {
        this.setState({ stats: ERROR_STAT, errorFetching: true });
        return;
      }
      this.setState({ stats: data.getOrgTotalEngagements.stats, errorFetching: false });
    } else {
      this.setState({ stats: ERROR_STAT, errorFetching: true });
      return;
    }

    if (getOrgHighestEngagements) {
      const { data, errors } = await getOrgHighestEngagements({
        createdAt,
        productShortName,
        organisationId,
        timezone
      });
      if (errors || !data || !data.getOrgHighestEngagements) {
        this.setState({ highestStats: ERROR_STAT, errorFetching: true });
      } else {
        this.setState({ highestStats: data.getOrgHighestEngagements.stats, errorFetching: false });
      }
    } else {
      this.setState({ errorFetching: true });
    }
  };

  tabClicked = (e) => {
    this.setState({ isTabInsights: e.selectedTabIndex === 0 });
  };

  render() {
    const {
      className = '',
      filters,
      width,
      history,
      getRacetrackAnalytics,
      organisationId,
      apolloClient,
      billingEntityCode,
      leaderboardOrderBy,
      leaderboardOrderByDirection
    } = this.props;
    const {
      stats,
      highestStats,
      isTabInsights,
      errorFetching,
      modalOffset
    } = this.state;

    const isSmall = width < NUMERIC_MEDIA_SIZES.small;

    const filterOptions = filters ? filters.map(({ label, id }) => (
    { label, value: id })
    ) : [];

    // Get the highest total value from the first 15 stats to scale the graph's height nicely
    const highestGraphTotal = Math.max(...highestStats.slice(0, 15).map(
      (v) => v.length > 4 ? v[4].value : 0
    ));

    const hasStats = stats.length > 0 && highestStats.length > 0;

    const showErrorSign = isTabInsights && errorFetching;
    const showInsightsPanel = isTabInsights && !errorFetching;
    const showStats = hasStats && !errorFetching;
    const showLeaderboard = !isTabInsights;
    return (
      <div
        className={cx('right-drawer-insights', className, {
          'right-drawer-insights__small': isSmall
        })}>

        <Tabs
          updateSelectedTabIndex={this.tabClicked}
          initialIndex={isTabInsights ? 0 : 1}>

          <div title="Insights" />
          <div title="Leaderboard" />
        </Tabs>
        {showErrorSign &&
        <div className="error-board">
            <SVG cacheRequests src={InsightsError} uniquifyIDs />
            <Text heading5>
              We&apos;re having difficulty displaying your insights...
            </Text>
            <Text heading6>
              Try refreshing the page or if the problem persists contact support
            </Text>
          </div>}

        {showInsightsPanel &&
        <>
            <div className="right-drawer-insights__header">
              <div className="right-drawer-insights__filters-list">
                <Dropdown
                defaultValue={filterOptions.length > 1 ? filterOptions[1] : ''}
                options={filterOptions}
                onChange={(newValue) => this.setState({ selectedFilter: newValue.value })}
                type="BUTTON" />

              </div>
            </div>
            {showStats &&
          <>
                <div className="right-drawer-insights__total-engagements">
                  <Text heading5>
                    Total Engagements
                  </Text>
                  <div className="right-drawer-insights__total-engagements__list">
                    {stats.map(({ label, value }, index) =>
                <div className="right-drawer-insights__total-engagements__list__item">
                        <div className="right-drawer-insights__total-engagements__list__item__label">
                          <ul>
                            <li style={{ color: COLOUR_LIST[index] }}>
                              <span>{label}</span>
                            </li>
                          </ul>
                        </div>
                        <div
                    className="right-drawer-insights__total-engagements__list__item__value">

                          {value}
                        </div>
                      </div>
                )}
                  </div>
                </div>
                <div className="right-drawer-insights__highest-engagements">
                  <Text heading5>
                    Top Engagements
                  </Text>
                  <div className="right-drawer-insights__highest-engagements__graph">
                    {highestStats.map((item, index) => {
                  if (item.length < 7) {return null;}

                  const [
                  itemVideoId,
                  itemSplashPageVisits,
                  itemElevateViews,
                  itemCTAClicks,,
                  itemRecipientName] =
                  item;

                  // Normalise the graph to the graph height
                  const graphRatio = highestGraphTotal / HEIGHT_OF_GRAPH;
                  const splashPageVisitsHeight = itemSplashPageVisits.value / graphRatio;
                  const elevateViewsHeight = itemElevateViews.value / graphRatio;
                  const CTAClicksHeight = itemCTAClicks.value / graphRatio;

                  if (index < NUMBER_OF_GRAPH_VALUES) {
                    return (
                      <div
                        className="right-drawer-insights__highest-engagements__graph__item"
                        onMouseEnter={() => {
                          this.setState({
                            modalOffset: this._mousePosition.y - MODAL_MOUSE_OFFSET
                          });
                        }}
                        onFocus={() => {}}>

                            <div
                          className="right-drawer-insights__highest-engagements__graph__hover"
                          style={{ top: modalOffset }}>

                              <div className="inner">
                                <Text heading5>
                                  {itemRecipientName.value}
                                </Text>
                                <div className="inner__item">
                                  <div className="inner__item__label">
                                    <ul>
                                      <li style={{ color: COLOUR_LIST[0] }}>
                                        <span>Splash Visits</span>
                                      </li>
                                    </ul>
                                  </div>
                                  <div
                                className="inner__item__value">

                                    {itemSplashPageVisits.value}
                                  </div>
                                </div>
                                <div className="inner__item">
                                  <div className="inner__item__label">
                                    <ul>
                                      <li style={{ color: COLOUR_LIST[1] }}>
                                        <span>Elevate Views</span>
                                      </li>
                                    </ul>
                                  </div>
                                  <div
                                className="inner__item__value">

                                    {itemElevateViews.value}
                                  </div>
                                </div>
                                <div className="inner__item">
                                  <div className="inner__item__label">
                                    <ul>
                                      <li style={{ color: COLOUR_LIST[2] }}>
                                        <span>CTA Clicks</span>
                                      </li>
                                    </ul>
                                  </div>
                                  <div
                                className="inner__item__value">

                                    {itemCTAClicks.value}
                                  </div>
                                </div>
                                {/* eslint-disable-next-line */}
                                <div
                              className="view-more"
                              onClick={() => {history.push(`elevate/insights/${itemVideoId.value}`);}}>

                                  View More
                                </div>
                              </div>
                            </div>
                            <div
                          style={{
                            height: `${splashPageVisitsHeight}px`,
                            backgroundColor: `${COLOUR_LIST[0]}`
                          }}
                          className="right-drawer-insights__highest-engagements__graph__item__section">

                              &nbsp;
                            </div>
                            <div
                          style={{
                            height: `${elevateViewsHeight}px`,
                            backgroundColor: `${COLOUR_LIST[1]}`
                          }}
                          className="right-drawer-insights__highest-engagements__graph__item__section">

                              &nbsp;
                            </div>
                            <div
                          style={{
                            height: `${CTAClicksHeight}px`,
                            backgroundColor: `${COLOUR_LIST[2]}`
                          }}
                          className="right-drawer-insights__highest-engagements__graph__item__section">

                              &nbsp;
                            </div>
                          </div>);

                  }

                  return null;
                })}
                  </div>
                  <div className="right-drawer-insights__highest-engagements__list">
                    {highestStats.map((item, index) => {
                  const [
                  itemVideoId,,,,,
                  itemRecipientName,
                  itemRecipientCompany] =
                  item;

                  return (
                    <div className="right-drawer-insights__highest-engagements__list__item">
                          <div
                        className="right-drawer-insights__highest-engagements__list__item__index">

                            {index + 1}
                            .
                          </div>
                          <div
                        className="right-drawer-insights__highest-engagements__list__item__name">

                            <Text heading5 noMargin>
                              {itemRecipientName.value || '-'}
                            </Text>
                            <Text body noMargin>
                              {itemRecipientCompany.value || '-'}
                            </Text>
                          </div>
                          <div
                        className="right-drawer-insights__highest-engagements__list__item__arrow">

                            <Button
                          type="TERTIARY"
                          onClick={() => {history.push(`elevate/insights/${itemVideoId.value}`);}}>

                              <Icon
                            name="linkext"
                            size={15} />

                            </Button>
                          </div>
                        </div>);

                })}
                  </div>
                </div>
              </>}

            {!showStats &&
          <div className="no-insights-available">
                <SVG cacheRequests src={NoInsightsAvailable} uniquifyIDs />
                <Text heading5>
                  No insights available at this time
                </Text>
                <Text heading6>
                  No engagement rates available for this time period.
                  Try selecting a different time period or create an Elevate!
                </Text>
              </div>}

          </>}

        {showLeaderboard &&
        <Leaderboard
          getRacetrackAnalytics={getRacetrackAnalytics}
          organisationId={organisationId}
          apolloClient={apolloClient}
          billingEntityCode={billingEntityCode}
          orderBy={leaderboardOrderBy}
          orderByDirection={leaderboardOrderByDirection} />}


      </div>);

  }
}